import { useSelector } from "react-redux";

import { unitTypeSelector } from "shared/components/UnitConverter/state";

export const useUnitType = () => {
  const unitType = useSelector(unitTypeSelector);

  return { unitType };
};
